import {Button, Dropdown, Modal} from "antd";
import {EllipsisOutlined, EyeOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

export default function LogRowMenu({row}) {
    const {t} = useTranslation();

    const showDetail = () => {
        Modal.info({
            title: t('Log Detail'),
            width: '80%',
            content: (
                <div style={{maxHeight: '60vh', overflow: 'auto'}}>
                    <pre style={{
                        backgroundColor: '#f5f5f5',
                        padding: 16,
                        borderRadius: 4,
                        fontSize: 12,
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-all'
                    }}>
                        {row.jsonData ? JSON.stringify(JSON.parse(row.jsonData), null, 2) : '-'}
                    </pre>
                </div>
            ),
            okText: t('Close'),
        });
    }

    const items = [
        {
            key: 'detail',
            label: t('View Detail'),
            icon: <EyeOutlined />,
            onClick: showDetail
        },
    ];

    return (
        <Dropdown menu={{items}} trigger={['click']}>
            <Button size="small" icon={<EllipsisOutlined />}>
                {row.id?.substring(0, 8)}...
            </Button>
        </Dropdown>
    );
}
